<script setup>
import config from '@/common/config'
import { formatBytes, get, post, serverDt } from '@/common/util'
import { useMemberStore, useMetaStore } from '@/stores'
import dayjs from 'dayjs'
import { storeToRefs } from 'pinia'
import { reactive, onMounted, onUnmounted } from 'vue'
const metaStore = useMetaStore()
const {upproctoasts}=storeToRefs(metaStore)
const meta = reactive({
  msg: '거리뷰 파일을 업로드 중입니다.',
  stage:'upload',
  progress: 0,
  loadedBytes: 0,
  totalBytes: 0,
  speed:0,
  currentfn:'',
  xhr:null
})

const props = defineProps({
  bpid: String,
  svid: String,
  svnm: String,
  linkdist: Number,
  detectptdist: Number,
  files: Array,
  upfiledt:Date,
  upfilenmeaext:String,
  upfilepostype:String,
  upproctype:String,
  upfilesection:String,
  serverpath:String,
  toastId: Number,
  callback: Function
})
const emit = defineEmits(['close-toast'])
function closeToast(){
  if(meta.bpid)delete upproctoasts[meta.bpid]
  emit('close-toast')
  if(props.callback)props.callback({bpid:meta.bpid,svid:props.svid})
}
function estimateCompletionTime(percent, startTimeStr) {
  const startTime = new Date(startTimeStr)
  if (percent <= 0||percent > 100)return
  if (isNaN(startTime))return
  const now = new Date()
  const elapsed = now - startTime
  const totalTime = elapsed / (percent / 100)
  const estimatedEndTime = startTime.getTime() + totalTime
  return estimatedEndTime
}
function calcTPS(currentCount,startTimeStr) {
  const now = Date.now();
  const startTime = new Date(startTimeStr)
  const elapsedMs = now - startTime.getTime();
  if (elapsedMs <= 0) return 0;
  const elapsedSeconds = elapsedMs / 1000;
  return currentCount / elapsedSeconds;
}
function diffToHMS(start, end) {
  const diffSec = dayjs(end).diff(dayjs(start), 'second');
  if (diffSec <= 0) return '0초';
  const h = Math.floor(diffSec / 3600);
  const m = Math.floor((diffSec % 3600) / 60);
  const s = diffSec % 60;
  let result = [];
  if (h > 0) result.push(`${h}시`);
  if (m > 0) result.push(`${m}분`);
  result.push(`${s}초`);

  return result.join(' ');
}
async function checkProc(){
  if(!meta.bpid)return
  else if(!upproctoasts[meta.bpid]){
    upproctoasts[meta.bpid]=props.toastId
  }
  meta.stage='processing'
  const res=await get('rest/authed/admin/data/backprocinfo/'+meta.bpid)
  if(!res.isSuccess){
    meta.msg='처리 상태 조회 실패'
    return setTimeout(closeToast,1000);
  }
  if(!meta.starttime)meta.starttime=dayjs(res.data.cdt).format('YYYY-MM-DD HH:mm:ss')
  meta.checktime=dayjs().format('YYYY-MM-DD HH:mm:ss')
  if(!res.data){
    meta.msg='대용량 업로드 완료'
    meta.binfo.current=meta.binfo.total
    return setTimeout(() => closeToast(),3000);
  }
  if (res.data.msg == 'started') {
    meta.msg = '처리가 시작되었습니다.';
  } else if (res.data.msg == 'gen_point') {
    meta.msg = '포인트를 생성 중입니다.';
  } else if (res.data.msg == 'proc_pano') {
    meta.msg = '파노라마를 등록중입니다.';
  } else if (res.data.msg == 'create_link') {
    meta.msg = '링크를 생성 중입니다.';
  } else if (res.data.msg == 'save_link') {
    meta.msg = '링크를 저장 중입니다.';
  } else if (res.data.msg == 'find_sv_byid') {
    meta.msg = '대상 데이터를 찾는 중입니다.';
  } else if (res.data.msg == 'sv_found') {
    meta.msg = '대상 데이터를 찾았습니다.';
  } else if (res.data.msg == 'organize_files') {
    meta.msg = '파일을 정리 중입니다.';
  } else if (res.data.msg == 'transfer_temp_files') {
    meta.msg = '임시 파일을 이동 중입니다.';
  } else if (res.data.msg == 'panoimg_tiling') {
    meta.msg = '파노라마 이미지를 타일링 중입니다.';
  } else if (res.data.msg == 'move_to_sv_gen') {
    meta.msg = '거리뷰 생성 프로세스로 진입합니다.';
  } else if (res.data.msg == 'refresh_layer') {
    meta.msg = '레이어를 갱신 중입니다.';
  } else if (res.data.msg == 'complete') {
    meta.msg = '거리뷰 생성이 완료되었습니다.';
    return closeToast()
  }
  meta.binfo=res.data
  meta.progress = Math.round((meta.binfo.current / meta.binfo.total) * 100)
  if(isNaN(meta.progress))meta.progress=0
  if(res.data.phaseStDt){
    meta.remainingTime = estimateCompletionTime(meta.progress, res.data.phaseStDt)
    if(meta.remainingTime){
      //meta.remainingTime=dayjs(meta.remainingTime).format('YYYY-MM-DD HH:mm:ss')
      meta.remainingTime=diffToHMS(new Date,meta.remainingTime)
    }else meta.remainingTime=''
    meta.tps=calcTPS(meta.binfo.current,res.data.phaseStDt)
    meta.tps=Math.round(meta.tps*100)/100
  }else{
    meta.remainingTime=null
  }
  setTimeout(checkProc,1000)
}
async function init() {
  if(props.bpid){
    meta.bpid=props.bpid
    return checkProc()
  }
  if (!props.files || props.files.length === 0) {
    metaStore.toast('파일 없음', false)
    closeToast()
    return
  }
  if(props.files.length==1)meta.currentfn=props.files[0].name
  else{
    try{
      meta.currentfn='['+props.files[0].webkitRelativePath.split('/')[0]+'] 폴더'
    }catch(e){
      meta.currentfn='다중파일'
    }
  }
  try {
    await post('rest/authed/admin/data/setsvstat', { id: props.svid, processstatus: 'uploading' })
  } catch (e) {
    metaStore.toast('상태 업데이트 실패', false)
    closeToast()
    return
  }

  const formData = new FormData()
  props.files.forEach(file => {
    formData.append('files', file)
  })
  formData.append('svid', props.svid)
  formData.append('linkdist', props.linkdist)
  formData.append('detectptdist', props.detectptdist)
  formData.append('upfiledt', serverDt(props.upfiledt))
  formData.append('upfilenmeaext', props.upfilenmeaext)
  formData.append('upfilepostype', props.upfilepostype)
  formData.append('upproctype', props.upproctype)
  meta.xhr = new XMLHttpRequest()
  meta.xhr.open('POST', config.backend+'rest/authed/admin/data/uploadsv')
  const memStore=useMemberStore()
  meta.xhr.setRequestHeader('Authorization',memStore.bearertoken);
  meta.xhr.upload.onprogress = (event) => {
    if (event.lengthComputable) {
      const now = Date.now()
      const elapsedSec = (now - meta.lastUpdateTime) / 1000
      const bytesDiff = event.loaded - meta.lastLoadedBytes
      if (elapsedSec > 0) {
        meta.speed = bytesDiff / elapsedSec
      }
      meta.loadedBytes = event.loaded
      meta.totalBytes = event.total
      meta.progress = Math.round((event.loaded / event.total) * 100)
      meta.lastUpdateTime = now
      meta.lastLoadedBytes = event.loaded
    }
  }
  meta.xhr.onload = () => {
    if (meta.xhr.status === 200) {
      const res=JSON.parse(meta.xhr.responseText)
      if(!res.isSuccess){
        if(res.msg=='no_svid')meta.msg='거리뷰 아이디가 없습니다.'
        if(res.msg=='no_uploaded_files')meta.msg='업로드된 파일이 없습니다.'
        if(res.msg=='no_matched_data')meta.msg='좌표와 일치하는 파노라마 이미지가 없습니다.'
        if(res.msg=='dup_files')meta.msg=`중복된 파일이 있습니다.[${res.data}]`
        if(res.msg=='no_uploaded_file')meta.msg=`업로드된 파일이 없습니다.[${res.data}]`
        if(res.msg=='no_suitable_file')meta.msg=`이미지 또는 GPS 파일이 없습니다.`
        return post('rest/authed/admin/data/setsvstat', { id: props.svid, processstatus: 'complete' },()=>{
          alert(meta.msg)
          setTimeout(() => closeToast(),3000)
        })
      }
      meta.progress = 100
      meta.loadedBytes = meta.totalBytes
      meta.msg='거리뷰 파일 업로드 완료'
      meta.bpid=res.data.bpid
      meta.stage='upload'
      setTimeout(checkProc,300);
    } else {
      meta.msg='업로드 에러'
      setTimeout(() => closeToast(),3000);
    }
  }
  meta.xhr.onerror = () => {
    metaStore.toast('업로드 중 오류 발생', false)
    closeToast()
  }
  meta.xhr.send(formData)
  meta.starttime=dayjs().format('YYYY-MM-DD HH:mm:ss')
}
function cancel(){
  if(!confirm('취소하시겠습니까'))return
  meta.xhr.abort()
  post('rest/authed/admin/data/setsvstat', { id: props.svid, processstatus: 'complete' }).then(()=>{
    metaStore.toast('업로드가 취소되었습니다',false)
    closeToast()
  })
}
onMounted(() => {
  init()
})
onUnmounted(() => {
  if(meta.xhr)meta.xhr.abort()
  if(meta.bpid)delete upproctoasts[meta.bpid]
})
</script>

<template>
  <button v-if="meta.stage=='processing'" class="cursor-pointer" style="border: 1px solid #fff;position: absolute;right: 8px;top: 8px;padding: 0 3px;border-radius: 5px;;" @click="closeToast">X</button>
  <div style="width: 450px;">
    <p>{{ meta.msg }}</p>
    <div class="progress-bar-background">
      <div class="progress-bar-fill" :style="{ width: meta.progress + '%' }"></div>
    </div>
    <p>대상거리뷰:{{ props.svnm }}({{ props.svid }})</p>
    <p v-if="meta.stage=='upload'">{{ meta.currentfn }}</p>
    <p v-if="meta.stage=='upload'">{{ meta.progress }}% [{{ formatBytes(meta.loadedBytes,false,true) }}/{{ formatBytes(meta.totalBytes,false,true) }}]</p>
    <p v-if="meta.stage=='upload' && meta.speed">속도:{{ formatBytes(meta.speed, false, true) }}/초</p>
    <p v-if="meta.stage=='upload'">남은용량:{{ formatBytes(meta.totalBytes - meta.loadedBytes,false,true) }}</p>
    <p v-if="meta.stage=='processing'&&meta.binfo">{{meta.binfo.current}}/{{ meta.binfo.total }}</p>
    <p>시작시간:{{ meta.starttime }}</p>
    <p v-if="meta.checktime">현재시간:{{meta.checktime}}</p>
    <p v-if="meta.stage=='processing'">진행률:{{meta.progress}}% ({{meta.tps}}p/s)</p>
    <p v-if="meta.stage=='processing'&&meta.remainingTime">현재작업 남은시간:{{meta.remainingTime}}</p>
    <button v-if="meta.stage=='upload'&&meta.progress<90" @click="cancel" style="width: 100%;border: 1px solid #fff;">{{ metaStore.t('cancel') }}</button>
  </div>
</template>

<style scoped>
.progress-bar-background {
  width: 100%;
  height: 6px;
  background: #d1d5db;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 8px;
}
.progress-bar-fill {
  height: 100%;
  background: #3b82f6;
  transition: width 0.2s ease;
}
</style>
